/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["cc-top-bar cc-top-bar-item.show-always{width:250px!important}  cc-top-bar cc-top-bar-item.show-always .title{max-width:250px!important}@media (max-width:410px){  cc-top-bar cc-top-bar-item.show-always{max-width:170px!important}  cc-top-bar cc-top-bar-item.show-in-mobile:not(:first-child){display:none!important}}"];
export { styles as styles };
